export const environment = {
  production: true,
  baseUrl:    window.location.hostname == 'televisallega.com' || window.location.hostname == 'interno.televisallega.com' || window.location.hostname == 'qa.televisallega.com' ? "https://api.televisallega.com"  : "https://apidev.televisallega.com",
  baseCMSUrl: window.location.hostname == 'televisallega.com' || window.location.hostname == 'interno.televisallega.com' || window.location.hostname == 'qa.televisallega.com' ? "https://cms.televisallega.com/" : "https://qacms.televisallega.com/",

  tokenUrl: null, // For IdentityServer/Authorization Server API. You can set to null if same as baseUrl
  loginUrl: '/login',
  linkedInClientId: "",
  linkedInRedirectUri: "",
  linkedInSecretId: "",
};
